// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopCustomerCardControllerAttachToAccountData } from './EshopCustomerCardControllerAttachToAccountData.gen';
import type { EshopCustomerCardControllerAttachToAccountErrors } from './EshopCustomerCardControllerAttachToAccountErrors.gen';
import type { EshopCustomerCardControllerAttachToAccountResponses } from './EshopCustomerCardControllerAttachToAccountResponses.gen';
import type { EshopCustomerCardControllerGetCustomerCardsData } from './EshopCustomerCardControllerGetCustomerCardsData.gen';
import type { EshopCustomerCardControllerGetCustomerCardsErrors } from './EshopCustomerCardControllerGetCustomerCardsErrors.gen';
import type { EshopCustomerCardControllerGetCustomerCardsResponses } from './EshopCustomerCardControllerGetCustomerCardsResponses.gen';
import type { EshopCustomerCardControllerGetCustomerProfilesByCardIdData } from './EshopCustomerCardControllerGetCustomerProfilesByCardIdData.gen';
import type { EshopCustomerCardControllerGetCustomerProfilesByCardIdErrors } from './EshopCustomerCardControllerGetCustomerProfilesByCardIdErrors.gen';
import type { EshopCustomerCardControllerGetCustomerProfilesByCardIdResponses } from './EshopCustomerCardControllerGetCustomerProfilesByCardIdResponses.gen';
import type { EshopCustomerCardControllerGetOneByChipNumberData } from './EshopCustomerCardControllerGetOneByChipNumberData.gen';
import type { EshopCustomerCardControllerGetOneByChipNumberErrors } from './EshopCustomerCardControllerGetOneByChipNumberErrors.gen';
import type { EshopCustomerCardControllerGetOneByChipNumberResponses } from './EshopCustomerCardControllerGetOneByChipNumberResponses.gen';
import type { EshopCustomerCardControllerGetOneByIdData } from './EshopCustomerCardControllerGetOneByIdData.gen';
import type { EshopCustomerCardControllerGetOneByIdErrors } from './EshopCustomerCardControllerGetOneByIdErrors.gen';
import type { EshopCustomerCardControllerGetOneByIdResponses } from './EshopCustomerCardControllerGetOneByIdResponses.gen';
import type { EshopCustomerCardControllerSetActiveMainCardData } from './EshopCustomerCardControllerSetActiveMainCardData.gen';
import type { EshopCustomerCardControllerSetActiveMainCardErrors } from './EshopCustomerCardControllerSetActiveMainCardErrors.gen';
import type { EshopCustomerCardControllerSetActiveMainCardResponses } from './EshopCustomerCardControllerSetActiveMainCardResponses.gen';
import type { EshopCustomerCardControllerSmartCardCheckData } from './EshopCustomerCardControllerSmartCardCheckData.gen';
import type { EshopCustomerCardControllerSmartCardCheckErrors } from './EshopCustomerCardControllerSmartCardCheckErrors.gen';
import type { EshopCustomerCardControllerSmartCardCheckResponses } from './EshopCustomerCardControllerSmartCardCheckResponses.gen';
import type { EshopCustomerCardControllerUpdateData } from './EshopCustomerCardControllerUpdateData.gen';
import type { EshopCustomerCardControllerUpdateErrors } from './EshopCustomerCardControllerUpdateErrors.gen';
import type { EshopCustomerCardControllerUpdateResponses } from './EshopCustomerCardControllerUpdateResponses.gen';
import type { EshopCustomerCardControllerValidateNumberData } from './EshopCustomerCardControllerValidateNumberData.gen';
import type { EshopCustomerCardControllerValidateNumberErrors } from './EshopCustomerCardControllerValidateNumberErrors.gen';
import type { EshopCustomerCardControllerValidateNumberResponses } from './EshopCustomerCardControllerValidateNumberResponses.gen';
import type { Options } from './Options.gen';

export class EshopCustomerCardController {
    /**
     * Get card info list for the given customer account.
     *
     * Field `stateIds` must be send as stateIds[]=value.
     */
    public static getCustomerCards<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerCardControllerGetCustomerCardsData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerCardControllerGetCustomerCardsResponses, EshopCustomerCardControllerGetCustomerCardsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-cards',
            ...options
        });
    }
    
    /**
     * Check if customer has active SMART_CARD_2 card.
     */
    public static smartCardCheck<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerCardControllerSmartCardCheckData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerCardControllerSmartCardCheckResponses, EshopCustomerCardControllerSmartCardCheckErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-cards/has-smart-card',
            ...options
        });
    }
    
    /**
     * Customer card by id
     */
    public static getOneById<ThrowOnError extends boolean = false>(options: Options<EshopCustomerCardControllerGetOneByIdData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerCardControllerGetOneByIdResponses, EshopCustomerCardControllerGetOneByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-cards/{id}',
            ...options
        });
    }
    
    /**
     * Update customer card.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static update<ThrowOnError extends boolean = false>(options: Options<EshopCustomerCardControllerUpdateData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerCardControllerUpdateResponses, EshopCustomerCardControllerUpdateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-cards/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Attach customer card to customer account.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **ATTACH_CUSTOMER_CARD_NOT_ALLOWED** - Attach customer card is not allowed in system configuration.<br>
     * + **INVALID_ACCOUNT** - Account does not exist or another customer is assigned to this account.<br>
     * + **SMART_CARD_NOT_FOUND** - Smart card with this number was not found.<br>
     * + **INVALID_CUSTOMER_CARD_TYPE** - Customer card can not be this type.<br>
     * + **ONLY_SPECIFIC_CARD_TYPE_ALLOWED** - This action can be perform only on the specific card type.<br>
     * + **CUSTOMER_CARD_MUST_BE_ACTIVE_TO_BE_ASSIGNED_TO_ACCOUNT** - Card must be active to be assigned to an account.<br>
     * + **ONLY_CHILD_CARD_CAN_BE_REGISTERED_AS_ASSIGNED** - Only a card belonging to a child can be registered as an assigned card.<br>
     * + **CHILD_CARD_CANNOT_BE_REGISTERED_TO_ACCOUNT** - A card belonging to a child cannot be registered to your account. You can register it as an assigned card in the designated section.<br>
     * + **INVALID_CUSTOMER_CARD** - Customer card does not exist or has invalid card state.<br>
     * + **CUSTOMER_CARD_CANNOT_BE_ATTACHED_TO_ACCOUNT** - Card with this number cannot be attached to this account.<br>
     * + **CUSTOMER_CARD_ALREADY_ATTACHED_TO_ACCOUNT** - Card is already attached to account.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.
     */
    public static attachToAccount<ThrowOnError extends boolean = false>(options: Options<EshopCustomerCardControllerAttachToAccountData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerCardControllerAttachToAccountResponses, EshopCustomerCardControllerAttachToAccountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-cards/attach-to-account',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Customer card by chip number
     */
    public static getOneByChipNumber<ThrowOnError extends boolean = false>(options: Options<EshopCustomerCardControllerGetOneByChipNumberData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerCardControllerGetOneByChipNumberResponses, EshopCustomerCardControllerGetOneByChipNumberErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-cards-by-chip-number/{number}',
            ...options
        });
    }
    
    /**
     * Set customer active card to active main card and block other active cards.
     */
    public static setActiveMainCard<ThrowOnError extends boolean = false>(options: Options<EshopCustomerCardControllerSetActiveMainCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerCardControllerSetActiveMainCardResponses, EshopCustomerCardControllerSetActiveMainCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-cards/{id}/active-main-card',
            ...options
        });
    }
    
    /**
     * Validate customer card number
     */
    public static validateNumber<ThrowOnError extends boolean = false>(options: Options<EshopCustomerCardControllerValidateNumberData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerCardControllerValidateNumberResponses, EshopCustomerCardControllerValidateNumberErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-cards/validate/{number}',
            ...options
        });
    }
    
    /**
     * Get customer profiles for the given card.
     */
    public static getCustomerProfilesByCardId<ThrowOnError extends boolean = false>(options: Options<EshopCustomerCardControllerGetCustomerProfilesByCardIdData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerCardControllerGetCustomerProfilesByCardIdResponses, EshopCustomerCardControllerGetCustomerProfilesByCardIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-cards/{id}/relational-customer-profiles',
            ...options
        });
    }
}
